import React, { useEffect, useRef } from 'react'
import { useTranslation } from 'next-i18next'
import styled from '@emotion/styled'

import Row from 'modules/ui/atoms/Layout/Row'
import { ecard } from 'models/StudioCampaign'
import { Ecard } from '../Ecard'

export type EcardSelectorProps = {
  radioGroupName: string
  cardList: ecard[]
  ecardId: number | undefined
  label: string
  onCardSelect: (...event: any[]) => void
  onEcardToggled?: (toggled: boolean) => void | undefined
  dataId?: string
}

const EcardSelectorContainer = styled.div`
  display: flex;
  flex-direction: column;
`

const StyledEcardContainer = styled.div<{ cardLength: number }>`
  flex-basis: 50%;
  display: inline-block;

  &:last-child {
    margin-right: 0px;
  }

  // Media query for mobile
  @media (max-width: 767px) {
    width: 82px;
  }
`

const StyledRow = styled.div`
  display: flex;
  flex-wrap: wrap;
`

const EcardSelector: React.FC<EcardSelectorProps> = (props) => {
  const { radioGroupName, cardList, ecardId, onCardSelect, dataId = '' } = props
  const containerRef = useRef<HTMLDivElement | null>(null)
  const { t } = useTranslation()

  useEffect(() => {
    // Focus the EcardSelectorContainer when the component renders
    containerRef.current?.focus()
  }, [])

  const handleCardSelect = (cardInfo: ecard) => {
    onCardSelect(cardInfo)
  }

  const onEcardSelectorClick = (cardInfo: ecard) => {
    onCardSelect(cardInfo)
  }

  const onEcardSelectorKeyDown = (event: React.KeyboardEvent, cardInfo: ecard) => {
    if (event.key === 'Enter' || event.key === ' ') {
      onCardSelect(cardInfo)
    }
  }

  return (
    <EcardSelectorContainer ref={containerRef} tabIndex={0}>
      {cardList.length > 0 ? (
        <StyledRow>
          {cardList.map((cardInfo, index) => {
            return (
              <StyledEcardContainer
                key={index}
                onClick={() => onEcardSelectorClick(cardInfo)}
                onKeyDown={(e) => onEcardSelectorKeyDown(e, cardInfo)}
                cardLength={cardList.length}
                data-id={dataId}
              >
                <Ecard
                  value={`${cardInfo.id}`}
                  src={cardInfo.image_url}
                  radioGroupName={radioGroupName}
                  checked={ecardId === cardInfo.id}
                  onChange={() => handleCardSelect(cardInfo)}
                />
              </StyledEcardContainer>
            )
          })}
        </StyledRow>
      ) : (
        <div style={{ textAlign: 'center' }}>
          {t('EcardSelector.noEcardsUploaded', 'No e-cards uploaded')}
        </div>
      )}
    </EcardSelectorContainer>
  )
}

export default EcardSelector
